import React from 'react';
import { isEmpty } from '@/utils/common-helpers';

type Props = {
    desc?: any;
    pageTitle: string;
    bg: string;
    white?: boolean;
    ndaText?: string;
    discussingRequirementText?: string;
    designingText?: string;
    developmentText?: string;
    deploymentText?: string;
    supportAndMaintenanceText?: string;
};

const HireProcess: React.FC<Props> = ({
    pageTitle,
    desc,
    bg,
    white,
    ndaText,
    designingText,
    developmentText,
    deploymentText,
    supportAndMaintenanceText,
    discussingRequirementText,
}) => {
    return (
        <section className={`section-py ${bg} process-section`}>
            <div className={white ? 'text-white container lg:container mx-auto' : 'container lg:container mx-auto'}>
                <div className="row grid md:grid-cols-12 !gap-y-0">
                    <div className="md:col-span-8 md:col-start-3 mb-5 md:mb-[70px] lg:mb-0">
                        <div className="flex flex-col gap-2.5 text-center">
                            <h2 className="mb-0">{pageTitle}</h2>
                            <p className={white ? 'text-white mb-0 fw-600' : 'mb-0 fw-600'}>{desc}</p>
                        </div>
                    </div>
                    <div className="md:col-span-12 xl:col-span-12 xxl:col-span10 text-center about-us-animation">
                        <div className="process-list process-list-about">
                            <div className={white ? 'process-item process-item-white text-center' : 'process-item text-center'}>
                                <div
                                    className={
                                        white
                                            ? 'process-icon process-icon-white mx-auto mb-4 grid rounded-full'
                                            : 'process-icon mx-auto mb-4 grid rounded-full'
                                    }
                                >
                                    <svg>
                                        <use xlinkHref="#ic-signin-nda" />
                                    </svg>
                                </div>
                                <p
                                    className={
                                        white
                                            ? 'text-white fw-500 px-2.5 mb-[15px] custom-min-height'
                                            : 'text-textcolor fw-500 px-2.5 mb-[15px] custom-min-height'
                                    }
                                >
                                    Signing NDA
                                </p>
                                <p
                                    className={
                                        white
                                            ? 'text-white fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                            : 'text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                    }
                                >
                                    {isEmpty(ndaText)
                                        ? 'Ensuring the protection of your data is one of the most critical steps in our process.'
                                        : ndaText}
                                </p>
                            </div>
                            <div className={white ? 'circle circle-white circle-reverse' : 'circle circle-reverse'} />
                            <div
                                className={
                                    white
                                        ? 'process-item  process-item-white process-item-reverse text-center'
                                        : 'process-item process-item-reverse text-center'
                                }
                            >
                                <div
                                    className={
                                        white
                                            ? 'process-icon process-icon-white process-icon-reverse mx-auto mb-4 grid rounded-full'
                                            : 'process-icon process-icon-reverse mx-auto mb-4 grid rounded-full'
                                    }
                                >
                                    <svg>
                                        <use xlinkHref="#ic-discussing" />
                                    </svg>
                                </div>
                                <p
                                    className={
                                        white
                                            ? 'text-white fw-500 px-2.5 mb-[15px] custom-min-height'
                                            : 'text-textcolor fw-500 px-2.5 mb-[15px] custom-min-height'
                                    }
                                >
                                    Discussing requirement
                                </p>
                                <p
                                    className={
                                        white
                                            ? 'text-white fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                            : 'text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                    }
                                >
                                    {isEmpty(discussingRequirementText)
                                        ? "Now that we have your goals, it's time to get started and work hard to achieve them."
                                        : discussingRequirementText}
                                </p>
                            </div>
                            <div className={white ? 'circle circle-white circle-2' : 'circle circle-2'} />
                            <div className={white ? 'process-item process-item-white text-center' : 'process-item text-center'}>
                                <div
                                    className={
                                        white
                                            ? 'process-icon process-icon-white mx-auto mb-4 grid rounded-full'
                                            : 'process-icon mx-auto mb-4 grid rounded-full'
                                    }
                                >
                                    <svg>
                                        <use xlinkHref="#ic-designing" />
                                    </svg>
                                </div>
                                <p
                                    className={
                                        white
                                            ? 'text-white fw-500 px-2.5 mb-[15px] custom-min-height'
                                            : 'text-textcolor fw-500 px-2.5 mb-[15px] custom-min-height'
                                    }
                                >
                                    Designing
                                </p>
                                <p
                                    className={
                                        white
                                            ? 'text-white fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                            : 'text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                    }
                                >
                                    {isEmpty(designingText)
                                        ? 'Creating a great design is more than just aesthetics.'
                                        : designingText}
                                </p>
                            </div>
                            <div
                                className={
                                    white ? 'circle circle-white circle-reverse circle-3' : 'circle circle-reverse circle-3'
                                }
                            />
                            <div
                                className={
                                    white
                                        ? 'process-item process-item-white process-item-reverse text-center'
                                        : 'process-item process-item-reverse text-center'
                                }
                            >
                                <div
                                    className={
                                        white
                                            ? 'process-icon process-icon-white mx-auto mb-4 grid rounded-full'
                                            : 'process-icon mx-auto mb-4 grid rounded-full'
                                    }
                                >
                                    <svg>
                                        <use xlinkHref="#ic-development" />
                                    </svg>
                                </div>
                                <p
                                    className={
                                        white
                                            ? 'text-white fw-500 px-2.5 mb-[15px] custom-min-height'
                                            : 'text-textcolor fw-500 px-2.5 mb-[15px] custom-min-height'
                                    }
                                >
                                    Development
                                </p>
                                <p
                                    className={
                                        white
                                            ? 'text-white fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                            : 'text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                    }
                                >
                                    {isEmpty(developmentText)
                                        ? 'Just like building brick and mortar, well-written code makes the difference.'
                                        : developmentText}
                                </p>
                            </div>
                            <div className={white ? 'circle circle-white circle-4' : 'circle circle-4'} />
                            <div className={white ? 'process-item process-item-white text-center' : 'process-item text-center'}>
                                <div
                                    className={
                                        white
                                            ? 'process-icon process-icon-white mx-auto mb-4 grid rounded-full'
                                            : 'process-icon mx-auto mb-4 grid rounded-full'
                                    }
                                >
                                    <svg>
                                        <use xlinkHref="#ic-deployment" />
                                    </svg>
                                </div>
                                <p
                                    className={
                                        white
                                            ? 'text-white fw-500 px-2.5 mb-[15px] custom-min-height'
                                            : 'text-textcolor fw-500 px-2.5 mb-[15px] custom-min-height'
                                    }
                                >
                                    Deployment
                                </p>
                                <p
                                    className={
                                        white
                                            ? 'text-white fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                            : 'text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                    }
                                >
                                    {isEmpty(deploymentText)
                                        ? "It's time to launch your application, build momentum, and move mountains."
                                        : deploymentText}
                                </p>
                            </div>
                            <div
                                className={
                                    white ? 'circle circle-white circle-reverse circle-5' : 'circle circle-reverse circle-5'
                                }
                            />
                            <div
                                className={
                                    white
                                        ? 'process-item process-item-white process-item-reverse text-center'
                                        : 'process-item process-item-reverse text-center'
                                }
                            >
                                <div
                                    className={
                                        white
                                            ? 'process-icon process-icon-white mx-auto mb-4 grid rounded-full'
                                            : 'process-icon mx-auto mb-4 grid rounded-full'
                                    }
                                >
                                    <svg>
                                        <use xlinkHref="#ic-support" />
                                    </svg>
                                </div>
                                <p
                                    className={
                                        white
                                            ? 'text-white fw-500 px-2.5 mb-[15px] custom-min-height'
                                            : 'text-textcolor fw-500 px-2.5 mb-[15px] custom-min-height'
                                    }
                                >
                                    Support and Maintenance
                                </p>
                                <p
                                    className={
                                        white
                                            ? 'text-white fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                            : 'text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                    }
                                >
                                    {isEmpty(supportAndMaintenanceText)
                                        ? 'We provide extensive support and maintenance services post-project deployment.'
                                        : supportAndMaintenanceText}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HireProcess;
